import { render, staticRenderFns } from "./PriceManagement2.vue?vue&type=template&id=074835d8&"
import script from "./PriceManagement2.vue?vue&type=script&lang=js&"
export * from "./PriceManagement2.vue?vue&type=script&lang=js&"
import style0 from "./PriceManagement2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports